


let base_url: string = 'https://imake-app.com';

export const environment = {
   production: false,
   ApiEndPoint2: `${base_url}:1116/api`,
   ApiEndPoint: `${base_url}:1114/api`,
   google_api_key : "AIzaSyD_U2-w1Zald01AAXfi4vO6EH35YYc0-hM"
};
